import React from 'react'
import PropTypes from 'prop-types'

function SubscriptionDocs({ subscriptions, handleSubscriptionClick }) {
  const buckets = new Map()

  // mapping out the subscriptions by category
  subscriptions &&
    subscriptions.map((doc) => {
      const category = doc.category
      if (buckets.get(category)) {
        const arr = buckets.get(category)
        arr.push(doc)
        buckets.set(doc.category, arr)
      } else {
        buckets.set(category, [doc])
      }
    })

  // so we can render them out in a collection of lists
  const renderArray = []
  buckets.forEach((subscriptions, key) => {
    const a = {
      key: key,
      subscriptions: subscriptions,
    }
    renderArray.push(a)
  })

  function renderBucket(bucket, i) {
    return (
      <React.Fragment key={bucket.key + i}>
        <h4 className="u-marginBottom3gu">{bucket.key}</h4>
        {bucket.subscriptions.map((doc, i) => {
          return (
            <div key={'doc' + i} className="u-marginBottom3gu u-textTight">
              <input
                checked={doc.checked}
                id={'modal-doc' + doc.id}
                onChange={handleSubscriptionClick}
                value={doc.id}
                type="checkbox"
                className="Subscription-checkbox"
                data-analytics="cesc-subscribe-checkbox"
              ></input>
              <label htmlFor={'modal-doc' + doc.id}>
                <p className="u-inlineBlock u-marginLeft1gu">{doc.name}</p>
              </label>
            </div>
          )
        })}
      </React.Fragment>
    )
  }

  return (
    <>
      {renderArray.map((bucket, i) => {
        return renderBucket(bucket, i)
      })}
    </>
  )
}

SubscriptionDocs.propTypes = {
  subscriptions: PropTypes.array,
  handleSubscriptionClick: PropTypes.func,
}

export default SubscriptionDocs
